import { createI18n } from 'vue-i18n';

const messages = {
  cn: {
    payment_coin: '充值币种',
    payment_address: '充值地址',
    payment_amount: '充值金额',
    payment_tips: '实际支付金额与订单必须保持一致，否则不会到账！',
    scan_to_pay: '扫码付款',
    qrcode_tip: '钱包扫码或者将付款信息复制粘贴到您的钱包',
    notes_title: '说明',
    notes_text1: '只能向该钱包充值 {code}，否则不可找回',
    notes_text2: '最小充值金额：{minText}，小于最小充值的金额将不会入账且不会退回',
    notes_text3: '实际支付金额与订单必须保持一致',
    notes_text4: '订单有效期60分钟,请在订单有效期内完成支付',
    notes_text5: '暂不支付合约转账',
    notes_text6: '请务必确认充值环境安全，防止信息被篡改或泄露',
    payment_RedirectUrl: '返回会员中心',
    phone_number: '手机号码',
    phone_number_tip: '手机号码格式有误',
    product_messages: '商品信息',
    product_name: "商品名称",
    order_message: '订单汇总',
    product_amount: '金额',
    buyer_names: '请输入购买人信息',
    email_address: '邮箱地址',
    enter_email: '输入邮箱',
    call: '称呼',
    enter_call: '输入称呼',
    unpaid: '未支付',
    payment_finish: '支付完成',
    sure: '确定',
    colse: '关闭',
    back: '返回',
    buyer_message: '购买人信息',
    copy_address: '复制地址',
    Currency: '请选择您想要支付的币种以完成支付',
    notes_txt1: '请在规定时间内完成以下付款',
    notes_txt2: '1.请确保在扣掉提币手续费后，转入钱包地址金额与订单相同，金额错误将无法到账！',
    notes_txt3: '2.只能往该地址充值{type}（{bi}），否则资产不可找回！',
    notes_txt4: '商家需求您提供以下信息以便完成交易，请输入完成以上信息。',
    notes_txt5: '订单已关闭，如期间已付款请关闭页面或者请重新提交订单！',
    notes_txt6: '请您耐心等待，区块链确认到账后，您的支付订单将会自动完成，请留意邮件通知！',
    notes_txt7: '注：邮件将作为商品购买凭证，收到后保存，便于与商家核对!',
    notes_txt9: '3.订单有效期为{time}分钟，请在订单有效期内进行充值，否则无法到账！',
    notes_txt8: '温馨提示',
    notes_txt10: '兑换汇率由Klickl Pay系统提供，以下支付金额仅供参考，以实际支付汇率为准',
    email_tip1: '邮箱格式不正确',
    email_tip2: '邮箱长度不正确',
    call_tip: '称呼长度不正确',
    order_number: '订单号',
    pay_types: '支付币种',
    pay_ceil: '指导汇率',

    text_desc_1: '请确保在扣掉提币手续费后，转入钱包地址金额与订单相同，金额错误将无法到账！',
    text_desc_2: '只能往该地址充值{type}（{bi}），否则资产不可找回！',
    text_desc_3: '请在订单有效期内进行充值，否则无法到账！',
    scan_to_rate: '汇率',
    scan_to_orderno: '订单号',
    pay_trade_time_txt1: '交易将在',
    pay_trade_time_txt2: '后关闭，请及时付款！',
    status_1: '待转账',
    status_2: '已转账',
    status_3: '链上确认中',
    status_4: '已完成',
    notes_txt_time_after: '',
    pay: '支付'
  },
  en: {
    payment_coin: 'Top Up Coin',
    payment_address: 'Top-up Address',
    payment_amount: 'Top-up Amount',
    payment_tips: 'The actual payment amount must be consistent with the order, otherwise it will not be credited!',
    scan_to_pay: 'Scan to pay',
    qrcode_tip: 'Scan with wallet or copy the payment info to your wallet',
    notes_title: 'Description',
    notes_text1: 'You can only pay {code} to this wallet, or it might be retrievable',
    notes_text2: 'Minimal Amount: , any attempt with the amount lower than this will not go through and won\'t be refundable',
    notes_text3: 'The actual payment amount must be the same as the amount instructed on the order',
    notes_text4: 'The order is valid for 60 minutes . Please complete the payment while the order is still valid',
    notes_text5: 'Contract payment is not available at the moment',
    payment_RedirectUrl: 'Back to member center',
    phone_number: 'Phone Number',
    phone_number_tip: 'Incorrectly formatted mobile phone number',
    product_messages: 'Order Summary',
    product_name: 'Product',
    order_message: 'Order Summary',
    product_amount: 'Amount',
    buyer_names: "Please confirm your personal details",
    email_address: 'Email',
    enter_email: 'Please enter',
    call: 'Name',
    enter_call: 'Please enter',
    unpaid: 'Pending',
    payment_finish: 'Click to confirm payment',
    back: 'Finish',
    sure: 'Continue',
    colse: 'close',
    buyer_message: 'Customer Information',
    copy_address: 'Copy address',
    Currency: 'Plese select the crypto currency for your payment ',
    notes_txt1: 'Plese complete the payment within',
    notes_txt2: '1.Please make sure that after deducting the withdrawal fee, the amount transferred to the wallet address is the same as the order, and the wrong amount will not be credited!',
    notes_txt3: '2.You can only deposit {type} ({bi}) to this address,Otherwise, the assets cannot be retrieved!',
    notes_txt4: 'The merchant needs you to provide the following information in order to complete the transaction, please enter and complete the above information.',
    notes_txt5: 'The order has been closed, if the payment has been made during the period, pleaseClose the page or please resubmit the order!',
    notes_txt6: 'Thank you for your payment. A confirmation emaill will be sent to the email account that you designated when you created your order after transaction is being  verified by the blockchain and confirmed by Klickl Pay.',
    notes_txt7: 'Note: The confirmaiton email will serve as the payment invoice from Klickl Pay.  If you made a payment but did not receive a confirmation email, please contact the merchant directly',
    notes_txt8: 'Reminder',
    notes_txt9: '3.The order is valid for {time} minutes, please recharge within the validity period of the order,{type} otherwise it will not be credited!',
    notes_txt10: 'The above payment amount is an estimate based on the indictive rate provided by the Klickl Pay system，real rate will be carried out during the transaction',
    email_tip1: 'E-mail format is incorrect',
    email_tip2: 'Incorrect email length',
    call_tip: 'Incorrect salutation length',
    order_number: 'Order Number',
    pay_types: 'Selected payment crypto',
    pay_ceil: 'Indictive Rate',

    text_desc_1: 'Please make sure that after deducting the withdrawal fee, the amount transferred to the wallet address is the same as the order, and the wrong amount will not be credited.',
    text_desc_2: 'You can only recharge {type}（{bi}） to this address, otherwise the assets cannot be retrieved.',
    text_desc_3: 'Please recharge within the validity period of the order, otherwise it will not be credited.',
    scan_to_rate: 'Rate',
    scan_to_orderno: 'Order Number',
    pay_trade_time_txt1: 'The transaction will be closed within',
    pay_trade_time_txt2: 'minutes, please pay as soon as possible',
    status_1: 'Pending transfer',
    status_2: 'Transferred',
    status_3: 'On-chain confirmation',
    status_4: 'Completed',
    notes_txt_time_after: '',
    pay: 'Pay'
  },
  it: {
    payment_coin: 'Ricarica valuta',
    payment_address: 'indirizzo di deposito',
    payment_amount: 'importo del deposito',
    payment_tips: 'L\'importo effettivo del pagamento deve essere coerente con l\'ordine. In caso contrario, non arriverà nell\'account!',
    scan_to_pay: 'Scansiona il codice QR di pagamento',
    qrcode_tip: 'scansiona il codice QR dell\'indirizzo del portafoglio o copia e incolla il link di pagamento nel tuo portafoglio',
    notes_title: 'Istruzioni',
    notes_text1: 'Solo {code} può essere ricaricato sul portafoglio; in caso contrario, non può essere recuperato.',
    notes_text2: 'Importo minimo di ricarica: {minText}, inferiore all\'importo minimo di ricarica non verrà accreditato e non verrà restituito.',
    notes_text3: 'L\'importo effettivo del pagamento deve essere coerente con l\'ordine.',
    notes_text4: 'L\'ordine è valido per 60 minuti .Si prega di completare il pagamento entro il periodo di validità dell\'ordine.',
    notes_text5: 'Il trasferimento del contratto non sarà pagato temporaneamente',
    notes_text6: 'Assicurati che l\'ambiente di ricarica sia sicuro per evitare che le informazioni vengano manomesse o trapelate.',
    payment_RedirectUrl: 'Ritorna al centro membri.',
    product_messages: '',

    copy_address: 'copia indirizzo',
    notes_txt1: 'Si prega di completare il seguente pagamento entro il termine stabilito',
    notes_txt5: "\'L\'ordine è stato chiuso, se il pagamento è stato effettuato durante il periodo, chiudi la pagina o invia nuovamente l\'ordine!",
    text_desc_1: 'Si prega di assicurarsi che dopo aver detratto la tassa di movimentazione per il ritiro di valuta, l\'importo trasferito nel portafoglio è lo stesso che nell\'ordine, e l\'importo sbagliato non sarà ricevuto!',
    text_desc_2: 'Puoi ricaricare solo {type}（{bi}） a questo indirizzo, altrimenti gli asset non possono essere recuperati!',
    text_desc_3: 'L\'ordine è valido per $hour ore, si prega di ricaricare entro il periodo di validità dell\'ordine, altrimenti non verrà accreditato!',
    scan_to_orderno: 'orderNumber',
    status_1: 'in attesa di trasferimento',
    status_2: 'Trasferito',
    status_3: 'Conferma sulla catena',
    status_4: 'completato',
    notes_txt_time_after: '',
    pay: 'Pay'
  },
  es: {
    payment_coin: 'Recarga de moneda',
    payment_address: 'Dirección de recarga',
    payment_amount: 'Importe de la recarga',
    payment_tips: 'El monto real del pago debe ser coherente con el pedido; de lo contrario, no se acreditará',
    scan_to_pay: 'Pago con código QR',
    qrcode_tip: 'Pase la cartera o copie y pegue la información de pago en su cartera',
    notes_title: 'Descripción',
    notes_text1: 'Solo puede agregar dinero a esta billetera{code}，De lo contrario, el dinero no se puede recuperar.',
    notes_text2: 'Cantidad mínima de recarga：{minText}，La cantidad inferior al depósito mínimo no se acreditará y no se reembolsará',
    notes_text3: 'El importe real pagado debe ser el mismo que el de la orden',
    notes_text4: 'Los pedidos son válidos durante 30 minutos (excepto para BTC 3 horas), por favor complete el pago dentro del período de validez del pedido',
    notes_text5: 'Apoyo a las transferencias de contratos',
    notes_text6: 'Asegúrese de que el entorno de la recarga es seguro para evitar la manipulación o la fuga de información',
    payment_RedirectUrl: 'Volver al Centro de Miembros',
    product_messages: '',

    copy_address: 'copiar dirección',
    notes_txt1: 'Por favor complete el siguiente pago dentro del plazo estipulado',
    notes_txt5: 'El pedido se ha cerrado, si el pago se ha realizado durante el período, cierre la página o vuelva a enviar el pedido.',
    text_desc_1: 'Asegúrese de que después de deducir la tarifa de retiro, la cantidad transferida a la dirección de la billetera sea la misma que la del pedido, ¡y no se acreditará la cantidad incorrecta!',
    text_desc_2: 'Solo puede recargar {type}（{bi}） a esta dirección; de lo contrario, los activos no se pueden recuperar.',
    text_desc_3: 'El pedido es válido por $hour hora, recargue dentro del período de validez del pedido; de lo contrario, no se acreditará.',
    scan_to_orderno: 'Número de orden',
    status_1: 'transferencia pendiente',
    status_2: 'transferido',
    status_3: 'Confirmación en cadena',
    status_4: 'terminado',
    notes_txt_time_after: '',
    pay: 'Pay'
  }
};

function browserLang() {
  let lang = navigator.language; // 浏览器语言判断
  lang = lang.substr(0, 2);
  switch (lang) {
    case 'zh-CN': // 中文
    case 'zh-Hans': // 中文
      lang = 'zh-Hans';
      break;
    case 'en': // 英文
      lang = 'en';
      break;
    case 'it': // 意大利
      lang = 'it';
      break;
    case 'es': // 西班牙
      lang = 'es';
      break;
    default:
      lang = 'en';
  }
  return lang;
}

// 2. Create i18n instance with options
const i18n = createI18n({
  locale: 'cn', // set locale
  fallbackLocale: 'cn', // set fallback locale
  messages, // set locale messages
  legacy: false, // enable Composition API
  globalInjection: true, // enable global injection for $t
  // If you need to specify other options, you can set other options
  // ...
});

// i18n.global.locale = browserLang();

export default i18n;
